export const BKK_TIMEZONE = "+07:00";
